import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@quasar/extras/material-icons/material-icons.css'

import 'quasar/src/css/index.sass'

import quasarIconSet from 'quasar/icon-set/svg-material-icons'

export const quasarOptions = {
  plugins: {}, // import Quasar plugins and add here
  iconSet: quasarIconSet
}
